<div class="flex">
    <ng-container
        *ngTemplateOutlet="
            columnsTemplate;
            context: { $implicit: distributedColumns }
        "
    ></ng-container>
</div>
